import React from 'react';
import { Modal, Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, Avatar, makeStyles } from '@material-ui/core';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

const useStyles = makeStyles((theme) => ({
    modalBox: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 480,
        backgroundColor: '#fff',
        borderRadius: '16px',
        boxShadow: 24,
        padding: '0 32px',
        outline: 'none',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    title: {
        textAlign: 'center',
        fontWeight: 700,
        fontSize: 24,
        margin: theme.spacing(4, 0, 2, 0),
    },
    table: {
        minWidth: 450,
        margin: theme.spacing(3, 0, 3, 0), 
    },
    tableCell: {
        fontWeight: 700,
        fontSize: 14,
        color: '#222',
        padding: '10px 10px',
    },
    okButton: {
        borderRadius: '999px',
        backgroundColor: '#ec6535',
        color: '#fff',
        fontWeight: 600,
        fontSize: 16,
        padding: '2px 32px', 
        margin: theme.spacing(2, 0, 4, 0),
        textTransform: 'none',
        minWidth: 120,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '&:hover': {
            backgroundColor: '#d85a2f',
        },
    },
    avatar: {
        width: 28,
        height: 28,
        marginRight: 8,
        display: 'inline-block',
        verticalAlign: 'middle',
    },
    updatedByCell: {
        display: 'flex',
        alignItems: 'center',
        fontWeight: 700,
        fontSize: 14,
    },
}));

// Helper to check if avatar is a valid image URL
function isValidImageUrl(url) {
    if (!url) return false;
    return /\.(jpg|jpeg|png|gif|webp)$/i.test(url);
}

const BLANK_USER_AVATAR = 'https://www.gravatar.com/avatar/?d=mp&s=64';

export default function ProcessFlowVersionHistoryDialog({ open, onClose, processFlow }) {
    const classes = useStyles();
    const flowName = processFlow?.processFlowName || 'Process Flow';
    // Dummy version history data
    const versionHistory = processFlow?.versionHistory || [];

    return (
        <Modal open={open} onClose={onClose}>
            <Box className={classes.modalBox}>
                <Typography className={classes.title}>
                    {flowName} - Version History
                </Typography>
                <TableContainer component={Paper} className={classes.table}>
                        <Table size="small">
                            <TableHead>
                                <TableRow style={{ background: '#F4F6F8' }}>
                                    <TableCell className={classes.tableCell}>Timestamp</TableCell>
                                    <TableCell className={classes.tableCell}>Updated By</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {versionHistory.map((row, idx) => (
                                    <TableRow key={idx}>
                                        <TableCell style={{ fontSize: 14, padding: '10px 10px' }}>{row.timestamp}</TableCell>
                                        <TableCell className={classes.updatedByCell}>
                                            <Avatar src={isValidImageUrl(row.avatar) ? row.avatar : BLANK_USER_AVATAR} className={classes.avatar} />
                                            {row.updatedBy}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                <Button className={classes.okButton} onClick={onClose} variant="contained" endIcon={<ChevronRightIcon style={{ fontSize: 20 }} />}>
                    Ok
                </Button>
            </Box>
        </Modal>
    );
} 